window.axios = require('axios');
import VueMq from 'vue-mq';

window.Vue = require('vue');

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        window.event = function (event) {
            if (!(el == event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', window.event)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', window.event)
    },
});
Vue.config.silent = true;
// Vue.config.devtools = true;

import Localization from './components/localization.vue';
import LocalizationMobile from './components/localization_mobile.vue';

Vue.component('localization', Localization);
Vue.component('localizationMobile', LocalizationMobile);

Vue.use(VueMq, {
    breakpoints: {
        mobile: 450,
        tablet: 993,
        desktop: Infinity,
    }
});

const app = new Vue({
    el: '#wrapper'
});

window.deleteLocFilter = function(text) {
    if(window.innerWidth > 1024) {
        app.$refs.localizationComponent.removeSearchCities(text);
    }
    else {
        app.$refs.localizationComponentMobile.removeSearchCities(text);
    }
}

window.parseUrl = function() {
    if(window.innerWidth > 1024) {
        app.$refs.localizationComponent.parseUrl();
    }
    else {
        app.$refs.localizationComponentMobile.parseUrl();
    }
};
